import { axios } from '@/utils/request'

const api = {
    clubList: '/wyhadminapi/club/clubList',
    clubGradeList: '/wyhadminapi/club/clubGradeList',
    editClubGradeNote: '/wyhadminapi/club/editClubGradeNote',
    okClubGrade: '/wyhadminapi/club/okClubGrade',
    refuseClubGrade: '/wyhadminapi/club/refuseClubGrade',
    clubDownloadUrl: '/wyhadminapi/club/clubDownloadUrl',
    clubDetail: '/wyhadminapi/club/clubDetail',
    editClub: '/wyhadminapi/club/editClub',
    getApplyOrderDetail: '/wyhadminapi/club/applyOrderDetail',
    editApplyOrder: '/wyhadminapi/club/editApplyOrder',
    getApplyUserDetail: '/wyhadminapi/club/memberDetail',
    editApplyUser: '/wyhadminapi/club/applyMemberEdit',
    refreshOrder: '/wyhadminapi/club/refreshOrder',
    setShoupaiAll: '/wyhadminapi/club/setShoupaiAll',
    setGradeAll: '/wyhadminapi/club/setGradeAll',

    getGoodsList: '/wyhadminapi/club/goodsList',
    deleteGoods: '/wyhadminapi/club/goodsDelete',
    setGoodsRank: '/wyhadminapi/club/setGoodsRank',
    setItemRank: '/wyhadminapi/club/setItemRank',
    editGoods: '/wyhadminapi/club/goodsEdit',
    addGoods: '/wyhadminapi/club/goodsAdd',
    getGoodsDetail: '/wyhadminapi/club/goodsDetail',
    getGoodsItemList: '/wyhadminapi/club/itemList',
    addItem: '/wyhadminapi/club/itemadd',
    editItem: '/wyhadminapi/club/itemedit',
    deleteItem: '/wyhadminapi/club/itemdelete',
    getItemDetail: '/wyhadminapi/club/itemDetail',

    getJiansheOrderList: '/wyhadminapi/club/jiansheOrderList',
    getJiansheDetail: '/wyhadminapi/club/jiansheDetail',
    editJianshe: '/wyhadminapi/club/editJianshe',
}

export default api

export function getClubGradeList(parameter) {
    return axios({
      url: api.clubGradeList,
      method: 'get',
      params: parameter
    })
  }
  
export function getClubList(parameter) {
  return axios({
    url: api.clubList,
    method: 'get',
    params: parameter
  })
}

export function getClubDownloadUrl(parameter) {
    return axios({
        url: api.clubDownloadUrl,
        method: 'get',
        params: parameter
    })
}

export function getClubDetail(parameter) {
  return axios({
    url: api.clubDetail,
    method: 'get',
    params: parameter
  })
}
export function editClub(parameter) {
  return axios({
    url: api.editClub,
    method: 'post',
    data: parameter
  })
}

export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}
export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function refreshOrder(parameter) {
    return axios({
        url: api.refreshOrder,
        method: 'post',
        data: parameter
    })
}
export function getGoodsList(parameter) {
    return axios({
        url: api.getGoodsList,
        method: 'post',
        data: parameter
    })
}
export function deleteGoods(parameter) {
    return axios({
        url: api.deleteGoods,
        method: 'post',
        data: parameter
    })
}
export function setGoodsRank(parameter) {
    return axios({
        url: api.setGoodsRank,
        method: 'post',
        data: parameter
    })
}
export function setItemRank(parameter) {
    return axios({
        url: api.setItemRank,
        method: 'post',
        data: parameter
    })
}
export function editGoods(parameter) {
    return axios({
        url: api.editGoods,
        method: 'post',
        data: parameter
    })
}
export function addGoods(parameter) {
    return axios({
        url: api.addGoods,
        method: 'post',
        data: parameter
    })
}
export function getGoodsDetail(parameter) {
    return axios({
        url: api.getGoodsDetail,
        method: 'post',
        data: parameter
    })
}
export function getGoodsItemList(parameter) {
    return axios({
        url: api.getGoodsItemList,
        method: 'post',
        data: parameter
    })
}
export function addItem(parameter) {
    return axios({
        url: api.addItem,
        method: 'post',
        data: parameter
    })
}
export function editItem(parameter) {
    return axios({
        url: api.editItem,
        method: 'post',
        data: parameter
    })
}
export function deleteItem(parameter) {
    return axios({
        url: api.deleteItem,
        method: 'post',
        data: parameter
    })
}
export function getItemDetail(parameter) {
    return axios({
        url: api.getItemDetail,
        method: 'post',
        data: parameter
    })
}
export function getJiansheOrderList(parameter) {
    return axios({
        url: api.getJiansheOrderList,
        method: 'post',
        data: parameter
    })
}
export function getJiansheDetail(parameter) {
    return axios({
        url: api.getJiansheDetail,
        method: 'post',
        data: parameter
    })
}
export function editJianshe(parameter) {
    return axios({
        url: api.editJianshe,
        method: 'post',
        data: parameter
    })
}

export function setShoupaiAll(parameter) {
    return axios({
        url: api.setShoupaiAll,
        method: 'post',
        data: parameter
    })
}
export function setGradeAll(parameter) {
    return axios({
        url: api.setGradeAll,
        method: 'post',
        data: parameter
    })
}
export function editClubGradeNote(parameter) {
    return axios({
        url: api.editClubGradeNote,
        method: 'post',
        data: parameter
    })
}
export function refuseClubGrade(parameter) {
    return axios({
        url: api.refuseClubGrade,
        method: 'post',
        data: parameter
    })
}
export function okClubGrade(parameter) {
    return axios({
        url: api.okClubGrade,
        method: 'post',
        data: parameter
    })
}